import { formatCurrency, formatDate, formatDatetime } from '@utils/format.js'
import type { LancamentoItem } from './financeiroTypes.js'

export function abrirRelatorioDespesas(
  lancamentos: LancamentoItem[],
  de: string,
  ate: string,
  nomeObra: string,
) {
  const filtrados = lancamentos
    .filter((l) => l.tipo !== 'receita' && (!de || l.data >= de) && (!ate || l.data <= ate))
    .sort((a, b) => a.data.localeCompare(b.data))

  const totaisCat: Record<string, number> = {}
  for (const l of filtrados) {
    totaisCat[l.categoria] = (totaisCat[l.categoria] ?? 0) + l.valor
  }

  const total = filtrados.reduce((s, l) => s + l.valor, 0)

  const linhas = filtrados
    .map(
      (l) => `
    <tr>
      <td>${formatDate(l.data)}</td>
      <td>${l.titulo}</td>
      <td>${l.categoria}</td>
      <td>${l.fornecedor ?? '—'}</td>
      <td style="text-align:right">${formatCurrency(l.valor)}</td>
      <td>${l.status}</td>
      <td>${l.documentoId ? '✅' : '—'}</td>
    </tr>`,
    )
    .join('')

  const linhasCat = Object.entries(totaisCat)
    .sort(([, a], [, b]) => b - a)
    .map(
      ([cat, v]) => `
    <tr><td>${cat}</td><td style="text-align:right"><strong>${formatCurrency(v)}</strong></td></tr>`,
    )
    .join('')

  const periodo =
    de || ate
      ? `${de ? formatDate(de) : 'início'} a ${ate ? formatDate(ate) : 'hoje'}`
      : 'Todo o período'

  const html = `
    <h1>Relatório de Despesas da Obra</h1>
    <p class="sub">${nomeObra} · ${periodo} · Gerado em ${formatDatetime(new Date().toISOString())}</p>
    <div class="summary">
      <div class="summary-card"><div class="summary-card__label">Total de despesas</div><div class="summary-card__value">${formatCurrency(total)}</div></div>
      <div class="summary-card"><div class="summary-card__label">Lançamentos</div><div class="summary-card__value">${filtrados.length}</div></div>
    </div>
    <h2>Totais por Categoria</h2>
    <table><thead><tr><th>Categoria</th><th>Total</th></tr></thead><tbody>${linhasCat}</tbody></table>
    <h2>Detalhamento</h2>
    <table>
      <thead><tr><th>Data</th><th>Descrição</th><th>Categoria</th><th>Fornecedor</th><th>Valor</th><th>Status</th><th>NF</th></tr></thead>
      <tbody>${linhas}</tbody>
      <tfoot><tr><td colspan="4"><strong>Total</strong></td><td style="text-align:right"><strong>${formatCurrency(total)}</strong></td><td colspan="2"></td></tr></tfoot>
    </table>`

  try {
    if (typeof window === 'undefined') return
    const win = window.open('', '_blank')
    if (!win) return
    win.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8"><title>Relatório de despesas</title>
  <style>
    * { box-sizing:border-box; margin:0; padding:0; }
    body { font-family:'DM Sans', system-ui, sans-serif; font-size:12px; color:#1a1814; padding:24px; }
    h1 { font-size:18px; margin-bottom:4px; }
    h2 { font-size:14px; margin:16px 0 6px; border-bottom:1px solid #dedad0; padding-bottom:4px; }
    p.sub { font-size:11px; color:#534e42; margin-bottom:16px; }
    table { width:100%; border-collapse:collapse; margin-bottom:12px; }
    th { background:#efede7; text-align:left; padding:5px 8px; font-size:11px; border:1px solid #dedad0; }
    td { padding:5px 8px; border:1px solid #dedad0; font-size:11px; }
    tfoot td { background:#f4f2ec; }
    .summary { display:flex; gap:24px; margin-bottom:16px; }
    .summary-card { border:1px solid #dedad0; border-radius:12px; padding:10px 16px; }
    .summary-card__label { font-size:10px; color:#534e42; }
    .summary-card__value { font-size:16px; font-weight:bold; }
    @media print { body { padding:0; } }
  </style>
</head>
<body>${html}<script>window.onload=()=>window.print()</script></body></html>`)
    win.document.close()
  } catch {
    /* noop */
  }
}
